export default __webpack_public_path__ + "static/media/gallery-wip-handle_06.b2508974.jpg";